module.exports = __webpack_public_path__ + "static/media/28.ac0075e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/28.svg
// module id = 399
// module chunks = 14